import { propClassName } from '@/styles/NewsletterSignup';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from '@/utils/cn';
import { withNonHTMLChildren } from '@/utils/withNonHTMLChildren';
import { withSafeInnerHTML } from '@/utils/withSafeInnerHTML';

export interface NewsletterSignupGroupProps extends ComponentProps<'div'> {
  colors?: ClassNameProp<'primary' | 'secondary'>;
  size?: ClassNameProp<'default'>;
  variant?: ClassNameProp<'default'>;
}

export const NewsletterSignupGroupComponent: Component<NewsletterSignupGroupProps> = ({
  children,
  className,
  colors,
  size,
  variant,
  ...props
}) => {
  const colorsClassName = propClassName('group_colors', colors, 'primary');
  const sizeClassName = propClassName('group_size', size ?? variant, 'default');
  const variantClassName = propClassName('group_variant', variant, 'default');
  const componentClassName = cn(colorsClassName, sizeClassName, variantClassName, className);

  return (
    <div {...withSafeInnerHTML(children)} className={componentClassName} {...props}>
      {withNonHTMLChildren(children)}
    </div>
  );
};
